import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, Form, Input, Checkbox } from 'antd';
const FormItem = Form.Item;

import Store from '../../script/store';
import Base64 from '../../script/base64';
import * as settingActions from '../../actions/setting_action';

class ChangePasswordFormModal extends Component {
  state={
    changePasswordFormOKLoading: false
  }

  submitChangePasswordForm = () => {
    this.changePasswordForm.smformRef.current.validateFields().then((values) => {
      if (values) {
        var params = {
          LoginId: this.changePasswordForm.smformRef.current.getFieldValue('LoginID'),
          OldPwd: Base64.base64decode(Store.get('localUserPwd')),
          NewPwd: this.changePasswordForm.smformRef.current.getFieldValue('password')
        };
        this.setState({ changePasswordFormOKLoading: true });
        this.props.settingActions.changePassword(params, (data)=>{
          this.setState({ changePasswordFormOKLoading: false });
          if (this.props.setState) {
            this.props.setState({
              userManageModalType: '',
              userManageModalShow: false
            });
          } else {
            this.props.closeModal();
          }
        });
      }
    });
  }

  render() {
    return (
      <div>
        <WrappedChangePasswordForm {...this.props} wrappedComponentRef={inst => this.changePasswordForm = inst}/>
        <div className="ant-modal-footer" style={{margin: '24px -24px -24px'}}>
          <Button key="submit" type="primary" onClick={this.submitChangePasswordForm} loading={this.state.changePasswordFormOKLoading}>确定</Button>
          <Button key="back" onClick={this.props.closeModal}>取消</Button>
        </div>
      </div>
    );
  }
}

class ChangePasswordForm extends Component {
  constructor(props) {
		super(props);
		this.state = {
      showPassword: false
		};
    this.smformRef=React.createRef()
    let { wrappedComponentRef } = props;
		if (typeof wrappedComponentRef=== 'function') {
			wrappedComponentRef(this); // 在这里把this暴露给`parentComponent`
		}
	}
  // state={
  //   showPassword: false
  // }

  componentDidMount(){
  }

  comparePassword = (rule, value, callback) => {
    const form = this.smformRef.current;
    if (value && value !== form.getFieldValue('password')) {
      callback('两次新密码不一致');
    } else {
      callback();
    }
  }

  render() {
    //表单方法
    // let { getFieldDecorator } = this.props.form;
    let { selectedUser, localUserName } = this.props;
    selectedUser = selectedUser || {};

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
      },
    };
    return (
      <Form className="basicCustomForm" ref={this.smformRef}>
        <FormItem label="用户名" {...formItemLayout} name='LoginID' initialValue={selectedUser.LoginID || '' || localUserName}>
        <Input disabled={true} />
        </FormItem>
        <FormItem label="新密码" {...formItemLayout} name='password' initialValue='' rules={[{ required: true, message: '必须指定新密码。' }]}>
        <Input type={this.state.showPassword ? "text" : "password"} />
        </FormItem>
        <FormItem label="确认新密码" {...formItemLayout} name='passwordConfirm' rules={[ { required: true, message: '必须确认新密码。' },
              { validator: this.comparePassword }]}>
           <Input type={this.state.showPassword ? "text" : "password"} />
        </FormItem>
        <FormItem {...formItemLayout}>
          <Checkbox checked={this.state.showPassword} onChange={()=>{this.setState({showPassword: !this.state.showPassword})}}>显示密码</Checkbox>
        </FormItem>
      </Form>
    );
  }
}

const WrappedChangePasswordForm = (ChangePasswordForm);
// export default ChangePasswordFormModal;
const mapStateToProps = (state) => {
  return {
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    settingActions: bindActionCreators(settingActions, dispatch)
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChangePasswordFormModal)
